'use client'

/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/semi */

import { $fontSize, Flex, styled } from '@acko-tech/building-blocks.ui.common'

export const RootContainer = styled.div`
  display: flex;
  margin: 28px 0 12px;
  gap: 16px;
`

export const AuthorImageContainer = styled.div`
  position: relative;
  width: 56px;
  height: 56px;
  border-radius: 44px;
  overflow: hidden;
  @media only screen and (max-width: 768px) {
    width: 48px;
    height: 48px;
  }
`

export const AuthorDetailsContainer = styled.span`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const Heading = styled.a`
  text-decoration: none;
  color: #040222;
  font-size: ${$fontSize.normal};
  &:hover {
    text-decoration: underline;
  }
`

export const SubHeading = styled(Flex)``
